/* src/app/front-layout/consortiums/consortium/consortium.component.css */
.cs-head {
  margin-top: 100px;
  width: 100%;
  height: 150px;
  background-image: url(/assets/images/cs_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cs-head h1 {
  font-size: 55px;
  font-weight: 600;
  color: #0077b6;
}
.exam-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}
.exam-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F8F8F8;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.exam-content {
  max-width: 60%;
}
.exam-content h2 {
  font-size: 20px;
  font-weight: bold;
}
.exam-content p {
  font-size: 14px;
  color: #555;
}
.read-more {
  background: #0077b6;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 30px;
  cursor: pointer;
}
.exam-image img {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
@media (max-width: 768px) {
  .cs-head {
    height: 120px;
    margin-top: 80px;
  }
  .cs-head h1 {
    font-size: 40px;
    text-align: center;
    padding: 0 15px;
  }
  .exam-item {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }
  .exam-content {
    max-width: 100%;
    margin-bottom: 15px;
  }
  .exam-content h2 {
    font-size: 18px;
    line-height: 25px;
  }
  .exam-content p {
    font-size: 13px;
    text-align: justify;
  }
  .read-more {
    display: block;
    margin: 10px auto;
    padding: 8px 15px;
    font-size: 14px;
  }
  .exam-image img {
    width: 100%;
    height: 80px;
    margin-top: 10px;
  }
}
@media (max-width: 480px) {
  .cs-head {
    height: 100px;
  }
  .cs-head h1 {
    font-size: 32px;
  }
  .exam-content h2 {
    font-size: 16px;
  }
  .exam-content p {
    font-size: 12px;
  }
}
/*# sourceMappingURL=consortium.component.css.map */
